import { useState } from "react";
import TodoAdd from "./components/TodoAdd";
import TodoPrint from "./components/TodoPrint";
import "./App.css";

const App = () => {
  const [list, setList] = useState([]);

  const addTask = (task) => {
    setList([...list, task]);
  };

  const deleteTask = (index) => {
    const newList = list.filter((_, i) => i !== index);
    setList(newList);
  };

  return (
    <div className="container">
      <h1>Todo App</h1>

      <TodoAdd addTask={addTask} />

      <TodoPrint list={list} deleteTask={deleteTask} />
    </div>
  );
}

export default App;
